import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../header/Header';
import styles from './layout.module.scss';
import { Box } from '@mui/material';
import { Footer } from '../footer/Footer';

export const Layout = () => {
  return (
    <>
      <div className={styles.wrapper}></div>
      <Header />
      <div className={styles.outlet}>
        <Box>
          <Outlet />
        </Box>
      </div>
      <Footer />
    </>
  );
};
